import React, { useEffect } from "react";
import BeaSend, { BeaSendProps } from "./BeaSend";
import CommunicationMediumProvider, { useCommunicationMedium } from "./CommunicationMediumProvider";
import FaxSend, { FaxSendProps } from "./FaxSend";
import { ProductUnion } from "../../../types/ProductUnion";
import { getCommunicationMedium } from "./communicationHelperFunctions";

export type CommunicationMediumProps = {
  product: ProductUnion;
  handleClose: () => void;
  overwrittenHandleSave?: Function;
  communicationDraft?:
    | {
        communicationMedium: "bea";
        recipientType: string;
        bea: BeaSendProps["beaDraft"];
      }
    | {
        communicationMedium: "fax";
        recipientType: string;
        fax: FaxSendProps["faxDraft"];
      };
};

export default function CommunicationMedium({
  product,
  handleClose,
  communicationDraft,
  overwrittenHandleSave,
}: CommunicationMediumProps) {
  return (
    <CommunicationMediumProvider
      product={product}
      handleClose={handleClose}
      initialCommunicationMedium={communicationDraft?.communicationMedium}
      initialRecipientType={communicationDraft?.recipientType}
    >
      <CommunicationMediumInner
        communicationDraft={communicationDraft}
        product={product}
        overwrittenHandleSave={overwrittenHandleSave}
      />
    </CommunicationMediumProvider>
  );
}

function CommunicationMediumInner({
  communicationDraft,
  product,
  overwrittenHandleSave,
}: Pick<CommunicationMediumProps, "communicationDraft" | "product" | "overwrittenHandleSave">) {
  const { communicationMedium, setCommunicationMedium, setRecipientType } = useCommunicationMedium();

  useEffect(() => {
    if (!communicationDraft) {
      setCommunicationMedium(getCommunicationMedium(product, ""));
      return;
    }
    setCommunicationMedium(communicationDraft.communicationMedium);
    setRecipientType(communicationDraft.recipientType ?? "");
  }, [communicationDraft]);

  switch (communicationMedium) {
    case "bea":
      return (
        <BeaSend
          beaDraft={communicationDraft?.communicationMedium === "bea" ? communicationDraft.bea : null}
          overwrittenHandleSave={overwrittenHandleSave}
        />
      );
    case "fax":
      return (
        <FaxSend
          faxDraft={communicationDraft?.communicationMedium === "fax" ? communicationDraft.fax : null}
          overwrittenHandleSave={overwrittenHandleSave}
        />
      );
    default:
      return null;
  }
}
